import React, { useState } from "react";
import "./App.css";
import { Box, Fab, Grid, ThemeProvider } from "@mui/material";
import SideBar from "./Layouts/SideBar";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Guider from "./Guid/components/Guider";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./Pages/Portfolio";
import { theme } from "./Themes/Theme";
import { QueryClient, QueryClientProvider } from "react-query";
import { isMobile } from "react-device-detect";
import { SideBarMobile } from "./Layouts/SideBarMobile";
import MenuIcon from "@mui/icons-material/Menu";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  const [mode, setMode] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme(mode)}>
        <BrowserRouter>
          <Box sx={{ flexGrow: 1, minHeight: "100vh", position: "sticky" }}>
            <Guider mode={mode}/>
            <Grid
              container
              spacing={2}
              height="100vh"
              sx={{
                height: "100%",
                position: "fixed",
                top: "2vh",
                overflow: "hidden",
                left: 0,
                right: 0,
                bottom: 0,
              }}
            >
              {isMobile ? (
                <>
                  <Fab
                    color="primary"
                    aria-label="Menu"
                    style={{
                      position: "absolute",
                      zIndex: "100",
                      margin: "5%",
                    }}
                    onClick={handleOpen}
                  >
                    <MenuIcon />
                  </Fab>
                  <SideBarMobile
                    open={open}
                    handleClose={handleClose}
                    mode={mode}
                    setMode={setMode}
                  />
                </>
              ) : (
                <Grid
                  item
                  xs={2}
                  sx={{ height: "100%", backgroundColor: "background.default" }}
                >
                  <SideBar mode={mode} setMode={setMode} />
                </Grid>
              )}
              <Grid
                item
                xs={isMobile ? 12 : 10}
                sx={{
                  display: "flex",
                  height: "100%",
                  overflowY: "scroll",
                  overflowX: "hidden",
                  backgroundColor: "background.paper",
                }}
              >
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/portfolio" element={<Portfolio />} />
                  <Route path="*" element={<div></div>}></Route>
                </Routes>
              </Grid>
            </Grid>
          </Box>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
